import React from "react";

import { Stack, Tooltip, TooltipProps } from "@mui/material";

import { InfoRounded } from "@mui/icons-material";

export const StyledTooltip = ({
  title,
  infoIcon = false,
  children,
  ...props
}: {
  title: string | React.ReactNode;
  infoIcon?: boolean;
} & TooltipProps) => {
  return (
    <Tooltip
      arrow
      enterDelay={750}
      enterNextDelay={750}
      title={
        infoIcon && title ? (
          <Stack direction={"row"} gap={1} alignItems={"flex-start"}>
            {infoIcon && (
              <InfoRounded sx={{ fontSize: "12px", marginTop: "3px" }} />
            )}
            {title}
          </Stack>
        ) : (
          title
        )
      }
      {...props}
    >
      {children}
    </Tooltip>
  );
};
